import { Button, HorizontalSpacer, Label, Layout, Panel } from "@mcleod/components";

export abstract class AutogenLayoutProcessCommissionsPost extends Layout {
    buttonPost: Button;
    horizontalspacer1: HorizontalSpacer;
    labelPostConfirmation: Label;
    panelPost: Panel;
}
